// extracted by mini-css-extract-plugin
export default {"carousel":"photo_slider_carousel__CNw1F","carouselItem":"photo_slider_carouselItem__BblwI","boxArrows":"photo_slider_boxArrows__iUOLY"};